import { useMemo } from "react";

import { useStableRest } from "../../utils/use-stable-rest";
import type { StepperRootAttributes, StepperViewModel, UseStepperOptions } from "./types-stepper";

/** ViewModel do Stepper.Root: orientação, variante e `compact` que os passos leem pelo contexto; sem JSX. */
export function useStepper({
  compact = false,
  orientation = "horizontal",
  variant = "default",
  testId,
  className,
  style,
  ...props
}: UseStepperOptions & StepperRootAttributes): StepperViewModel {
  const rest = useStableRest(props);

  return useMemo(
    () => ({ compact, orientation, variant, testId, className, style, rest }),
    [compact, orientation, variant, testId, className, style, rest],
  );
}
